import React, { useContext } from 'react';
import { Button, Modal, Row, Col } from 'react-bootstrap';
import CargaDuplicada from "../../../../assets/img/carga duplicada.svg";
import CargaExcedida from "../../../../assets/img/carga excedida.svg";
import ErrorIcon from "../../../../assets/img/error-icon.png";
import SuccessIcon from "../../../../assets/img/success-icon.png";
import { MessageContext } from '../context';



import './confirm-change.scss'
export const ModalConfirmChangeComponent = ({
    visible = false,
    onToggle,
    success = false
}) => {

    const responseData = useContext(MessageContext);
    //const messages={true:"Datos enviados.",false:"Se produjo un error al enviar los datos."}

    // Función para poner en negrita el texto entre comillas
    const renderMessageWithBoldQuotedText = (message) => {
        const match = message.match(/"([^"]+)"/);
        if (!match) return message;

        const [fullMatch] = match;
        const parts = message.split(fullMatch);

        return (
            <>
                {parts[0]}
                <strong>{fullMatch}</strong>
                {parts[1]}
            </>
        );
    };

    return (
        <Modal
            size={"md"}
            aria-labelledby="contained-modal-title-vcenter"
            show={visible}
            centered
            onHide={onToggle}
        >
            {/* <Modal.Header  className='custom-header'>                            
            </Modal.Header> */}

            <Modal.Body style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
                <img
                    // src={!responseData.error ? SuccessIcon : SuccessIcon} 
                    src={
                        responseData.icon === "error"
                            ? ErrorIcon
                            : responseData.icon === "success"
                                ? SuccessIcon
                                : responseData.icon === "info"
                                    ? CargaDuplicada
                                    : responseData.icon === "info-error"
                                        ? CargaExcedida
                                        : SuccessIcon
                    }
                    alt="Message" style={{ width: "50px" }} />
                <div
                    className="header-familygroup-information mt-2"
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        textAlign: "center",
                    }}
                >
                    <p
                        style={{
                            fontSize: "16px",
                            marginBottom: "0.5rem",
                            color: "#111827",
                        }}
                    >
                        {renderMessageWithBoldQuotedText(responseData.message)}
                    </p>

                    {responseData.message2 && (
                        <p
                            style={{
                                fontSize: "14px",
                                color: "#4B5563",
                                marginBottom: "1.5rem",
                            }}
                        >
                            {responseData.message2}
                        </p>
                    )}
                </div>
                <div className='politica-proteccion-pshb'>
                    <div className='section-edit-information'>
                        <section>
                            <Row>
                                <Col md={12}>
                                    <div className="row mt-1">
                                        <div className="col-md-12 family-add-buttons" style={{ paddingBottom: "10px" }}>
                                            <div className="btn btn-hb-primary-without-border" onClick={() => onToggle()}>Cerrar</div>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </section>
                    </div>
                </div>
            </Modal.Body>
            {/* <Modal.Footer>                
                <Button className='btn2-color3-r' variant="primary" onClick={()=>onToggle()}>Cerrar</Button>
            </Modal.Footer> */}

        </Modal>
    )
}
